export const errorChangingName = 'Error updating invite code name!';
export const successChangingName = 'Updated invite code name!';
export const errorRemovingPromo = 'Error removing promo!';
export const successRemovingPromo = 'Successfully removed promo!';
export const successDeactivated = 'Successfully deactivated promo!';
export const successReactivated = 'Successfully re-activated promo!';
export const inviteCodeLabel = 'INVITE CODE';
export const inviteCodePlaceholder = 'Invite code name...';
export const buttonDeactivated = 'deactivate';
export const buttonReactivated = 're-activate';
export const promotionsTitle = 'PROMOTIONS';
export const addPromoHover = 'add a promo to this invite code';
export const addPromoButtonAlt = 'add';
